
import i18n from '@/i18n';
export default [
    {
        get text() { return i18n?.global?.t('tableHeaders.id')},
        value: 'id',
        sortable: true,
    },
    {
        get text() { return i18n?.global?.t('tableHeaders.name')},
        value: 'title',
        width: 200,
        sortable: true,
    },
    {
        get text() { return i18n?.global?.t('tableHeaders.category')},
        value: 'category_id',
        sortable: true,
        width: 140
    },

    {
        get text() { return i18n?.global?.t('tableHeaders.equipment')},
        value: 'equipment_id',
        sortable: true,
    },
    {
        get text() { return i18n?.global?.t('tableHeaders.symbol')},
        value: 'equipment_symbol',
    },
    {
        get text() { return i18n?.global?.t('common.productionLine')},
        value: 'prod_line',
    },
    {
        get text() { return i18n?.global?.t('tableHeaders.criticality')},
        value: 'criticality',
        sortable: true,
    },
    {
        get text() { return i18n?.global?.t('tableHeaders.status')},
        value: 'flow_state_name',
        sortable: false,
    },
    {
        get text() { return i18n?.global?.t('tableHeaders.department')},
        value: 'department',
        sortable: true,
    },
    {
        get text() { return i18n?.global?.t('tableHeaders.created')},
        value: 'created_at',
        sortable: true,
    },
    {
        get text() { return i18n?.global?.t('common.scheduledOn')},
        value: 'scheduled_on',
        sortable: true,
    },
    {
        get text() { return i18n?.global?.t('processes.finished_at')}, 
        value: 'finished_at',
        sortable: true,
    },
    {
        get text() { return i18n?.global?.t('tableHeaders.createdBy')},
        value: 'created_by',
        sortable: true,
    },
    {
        get text() { return i18n?.global?.t('issues.responsibleUser')},
        value: 'responsible_user', 
        sortable: true,
    },
    {
        get text() { return i18n?.global?.t('tableHeaders.fp')},
        value: 'formal_confirm_at',
        sortable: true,
    },
    { value: 'operation', fixed: true, width: 54 },
];